// extracted by mini-css-extract-plugin
export default {"nudgeMessage":"SbatGroupNudgeMessage_nudgeMessage__toBKK"};